import { render, staticRenderFns } from "./CloudDisk.vue?vue&type=template&id=65ce23fa&scoped=true"
import script from "./CloudDisk.vue?vue&type=script&lang=js"
export * from "./CloudDisk.vue?vue&type=script&lang=js"
import style0 from "./CloudDisk.vue?vue&type=style&index=0&id=65ce23fa&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "65ce23fa",
  null
  
)

export default component.exports